(() => {
  const initialise = (root) => {
    if (root.dataset.contactReady === 'true') return;
    root.dataset.contactReady = 'true';
    if (root.querySelector('[data-contact-response]')) return;
    const params = new URLSearchParams(window.location.search);
    const material = (params.get('material') || '').toLowerCase();
    const materialInput = root.querySelector('[data-contact-material]');
    const topicInput = root.querySelector('[data-contact-topic]');
    const topic = (params.get('topic') || '').toLowerCase();
    const numberFromQuery = (key, min, max, integer = false) => {
      const raw = params.get(key);
      if (!raw || !/^\d+(?:\.\d{1,2})?$/.test(raw)) return null;
      const value = Number(raw);
      if (!Number.isFinite(value) || value < min || value > max) return null;
      if (integer && !Number.isInteger(value)) return null;
      return value;
    };
    let hasQuoteDetails = false;
    if (materialInput && ['pvc', 'leatherette'].includes(material)) {
      materialInput.value = material === 'pvc' ? 'PVC' : 'Leatherette';
      hasQuoteDetails = true;
    }
    [['width', 0.5, 5, false], ['height', 0.5, 5, false], ['quantity', 12, 5000, true]].forEach(([key, min, max, integer]) => {
      const value = numberFromQuery(key, min, max, integer);
      const input = root.querySelector(`[data-contact-${key}]`);
      if (input && value !== null) {
        input.value = String(value);
        hasQuoteDetails = true;
      }
    });
    if (topicInput) {
      if (topic === 'quote' || topic === 'custom-size-quote' || params.get('quote') === '1' || hasQuoteDetails) topicInput.value = 'Custom size quote';
      else if (topic === 'artwork') topicInput.value = 'Artwork help';
      else if (topic === 'order') topicInput.value = 'Order question';
    }
  };
  const initialiseAll = (scope) => {
    if (scope.matches?.('[data-lc-contact]')) initialise(scope);
    scope.querySelectorAll('[data-lc-contact]').forEach(initialise);
  };
  initialiseAll(document);
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
